import { vnTemplate } from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";
import * as am4core from "@amcharts/amcharts4/core" ;
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";

declare let ko: any;
declare let AmCharts: any;

export class amCharts_v4_date_line_template extends vnTemplate{

    protected getTemplateHtml(): string{

        return `<div data-bind="attr: {id: idChart}, style: {width: csswidth, height: cssheight}"></div>`;
    }

    public getTemplateName(): string{

        return "amCharts_v4_date_line_template";
    }

    protected buildViewModel(): any{

        let _this = this;
        return  {

            idChart: ko.observable("chartDiv_" + _this.idElement),
            date: ko.observable(""),
            csswidth: ko.observable("98%"),
            cssheight: ko.observable("550px"),
            yaxis: ko.observableArray([]),
            ranges: ko.observableArray([]),
            disableClickableLegend: ko.observable(0),
            enableXScrollbar: ko.observable(0),
            autoRotateLabels: ko.observable(0),
            labelMaxWidth: ko.observable(null),
        };
    }

    protected getMainElementClasses(): Array<string>{

        return ["dateGraph"];
    }

    public setDate(date){

        this.getTemplateViewModel().date(date);
    }

    public setYaxis(axis){

        this.getTemplateViewModel().yaxis(axis);
    }

    public setRanges(ranges){

        this.getTemplateViewModel().ranges(ranges);
    }

    public setDisableClickableLegend(value){

        this.getTemplateViewModel().disableClickableLegend(value);
    }

    public setEnableXScrollbar(value){

        this.getTemplateViewModel().enableXScrollbar(value);
    }

    public setLabelMaxWidth(value){

        this.getTemplateViewModel().labelMaxWidth(value);
    }

    public setAutoRotateLabels(value){

        this.getTemplateViewModel().autoRotateLabels(value);
    }

    public setCssHeight(value){

        this.getTemplateViewModel().cssheight(value);
    }

    public setCssWidth(value){

        this.getTemplateViewModel().csswidth(value);
    }

    public drawChart(chartData){

        let _this = this;

        /* Chart code */
        am4core.options.autoDispose = true;
        am4core.unuseAllThemes();

        // Create chart instance
        let chart = am4core.create("chartDiv_" + _this.idElement, am4charts.XYChart);

        // Needed to have the date show up in the correct position
        chart.dateFormatter.utc = true;

        // Add data
        chart.data = chartData;

        // Create axes
        let xAxis = chart.xAxes.push(new am4charts.DateAxis());

        xAxis.dataFields.date = this.getTemplateViewModel().date();

        xAxis.dateFormats.setKey("day", "yyyy-MM-dd");
        xAxis.periodChangeDateFormats.setKey("day", "yyyy-MM-dd");
        xAxis.dateFormats.setKey("week", "yyyy-MM-dd");
        xAxis.periodChangeDateFormats.setKey("week", "yyyy-MM-dd");
        xAxis.dateFormats.setKey("month", "yyyy-MM-dd");
        xAxis.periodChangeDateFormats.setKey("month", "yyyy-MM-dd");

        if (this.getTemplateViewModel().labelMaxWidth() != null){

            var label = xAxis.renderer.labels.template;
            label.truncate = true;
            label.maxWidth = this.getTemplateViewModel().labelMaxWidth();
        }

        if (this.getTemplateViewModel().autoRotateLabels() == 1){

            xAxis.events.on("sizechanged", function (ev){

                var axis = ev.target;
                var cellWidth = axis.pixelWidth / (axis.endIndex - axis.startIndex);
                if (cellWidth < axis.renderer.labels.template.maxWidth){
                    axis.renderer.labels.template.rotation = -45;
                    axis.renderer.labels.template.horizontalCenter = "right";
                    axis.renderer.labels.template.verticalCenter = "middle";
                } else {
                    axis.renderer.labels.template.rotation = 0;
                    axis.renderer.labels.template.horizontalCenter = "middle";
                    axis.renderer.labels.template.verticalCenter = "top";
                }
            });
        }

        xAxis.renderer.labels.template.location = 0.5;
        xAxis.renderer.grid.template.location = 0.5;
        xAxis.renderer.minGridDistance = 1;

        let yAxes = [];
        for (let yAxis of this.getTemplateViewModel().yaxis()){

            if (typeof yAxes[yAxis.axis] === 'undefined'){
                yAxes[yAxis.axis] = chart.yAxes.push(new am4charts.ValueAxis());
            }

            let series = chart.series.push(new am4charts.LineSeries());

            series.dataFields.valueY = yAxis.field;

            if (yAxis.hasOwnProperty('tooltipfield')){

                series.dataFields.customValue = yAxis.tooltipfield;
            }else {

                series.dataFields.customValue = yAxis.field;
            }
            series.dataFields.dateX = this.getTemplateViewModel().date();
            series.strokeOpacity = 1;
            series.strokeWidth = 2;
            series.fill = am4core.color(yAxis.color);
            series.stroke = am4core.color(yAxis.color);
            series.yAxis = yAxes[yAxis.axis];
            series.name = yAxis.name;
            series.tooltipText = "{name}: [bold]{customValue}[/]";
            series.smoothing = "monotoneX";
            series.showOnInit = true;

            if (yAxis.hasOwnProperty('strokeDasharray')) {

                series.strokeDasharray = yAxis.strokeDasharray;
            }

            if (yAxis.hasOwnProperty('hiddenInLegend')) {

                series.hiddenInLegend = yAxis.hiddenInLegend;
            }

            if (yAxis.hasOwnProperty('patternFill') && yAxis.patternFill == true) {

                let pattern = new am4core.LinePattern();
                pattern.width = 10;
                pattern.height = 10;
                pattern.stroke = am4core.color(yAxis.color);
                pattern.strokeWidth = 2;
                pattern.rotation = 45;

                series.fill = pattern;

                series.tooltip.getFillFromObject = false;
                series.tooltip.background.fill = am4core.color(yAxis.color);

            }


            yAxes[yAxis.axis].renderer.line.strokeOpacity = 1;
            yAxes[yAxis.axis].renderer.line.strokeWidth = 2;
            yAxes[yAxis.axis].renderer.line.stroke = series.stroke;
            yAxes[yAxis.axis].renderer.labels.template.fill = series.stroke;
            yAxes[yAxis.axis].renderer.opposite = yAxis.opposite;

            let interfaceColors = new am4core.InterfaceColorSet();


            let bullet = series.bullets.push(new am4charts.CircleBullet());
            bullet.circle.stroke = interfaceColors.getFor("background");
            bullet.circle.strokeWidth = 2;

            yAxes[yAxis.axis].renderer.line.strokeOpacity = 1;
            yAxes[yAxis.axis].renderer.line.strokeWidth = 2;
            yAxes[yAxis.axis].renderer.line.stroke = am4core.color('#1886ff');
            yAxes[yAxis.axis].renderer.labels.template.fill = am4core.color('#1886ff');
            yAxes[yAxis.axis].renderer.opposite = yAxis.opposite;
        }

        for (let range of this.getTemplateViewModel().ranges()){

            let addrange = xAxis.axisRanges.create();
            addrange.date = range.date;
            addrange.endDate = range.endDate;
            addrange.axisFill.fill = am4core.color(range.fill);
            addrange.axisFill.fillOpacity = range.fillOpacity;
            addrange.locations.category = range.locationsCategory;
            addrange.locations.endCategory = range.locationsEndCategory;
        }

        // Add legend
        chart.legend = new am4charts.Legend();

        if (this.getTemplateViewModel().disableClickableLegend() == 1){

            chart.legend.itemContainers.template.clickable = false;
            chart.legend.itemContainers.template.focusable = false;
            chart.legend.itemContainers.template.cursorOverStyle = am4core.MouseCursorStyle.default;
        }

        if (this.getTemplateViewModel().enableXScrollbar() == 1){

            chart.scrollbarX = new am4charts.XYChartScrollbar();
        }

        if (chartData.length === 0 ){

            let message = chart.createChild(am4core.Label);
            message.text = "No data available.";
            message.fontSize = 15;
            message.align = "center";
            message.isMeasured = false;

            message.x = am4core.percent(50);
            message.y = am4core.percent(50);
            message.verticalCenter = "middle";
            message.horizontalCenter = "middle";
        }

        // Add cursor
        chart.cursor = new am4charts.XYCursor();

        return chart;
    }
}



// WEBPACK FOOTER //
// ./js/components/templates/amCharts_v4_date_line_template.ts